<template>
  <div>
    <div class="flex items-center justify-center min-h-screen p-4 overflow-hidden">
      <div class="relative z-10 w-96">
        <div class="flex justify-center">
          <span class="mt-8 mb-8">
            <a href="https://ahaslides.com">
              <aha-logo
                width="140"
                height="24"
                viewBox="0 0 9600 1602"
              />
            </a>
          </span>
        </div>

        <div class="shadow-panel rounded-3xl bg-base-0 p-8">
          <h2 class="mb-6 text-center text-lg w-80 mx-auto">
            Make your Zoom meeting <br> awesome with AhaSlides
          </h2>

          <div class="flex justify-center">
            <aha-button @click="startZoomMeetingUsingAhaSlides" class="mb-4">
              Open AhaSlides in a Zoom meeting
            </aha-button>
          </div>
          <span class="image-pallet">
            <img src="@/assets/images/elements/pallet.svg">
          </span>
        </div>

        <span class="absolute bottom-0 hidden lg:block -right-20">
          <img src="@/assets/images/elements/tree.svg">
        </span>

        <div class="h-28" />
      </div>

      <BackDrop />

      <span class="absolute hidden lg:block top-1/4 right-2/3">
        <img src="@/assets/images/elements/music-note.svg">
      </span>
    </div>
  </div>
</template>

<script>
import zoomSdk from '@zoom/appssdk'
import BackDrop from '@/components-v2/common/auth/BackDrop.vue'

export default {
  name: 'ZoomMainClientPage',
  components: {
    BackDrop,
  },

  mounted() {
    // Code to run when the component is mounted goes here
  },
  methods: {
    startZoomMeetingUsingAhaSlides() {
      zoomSdk.launchAppInMeeting()
    },
  },
}
</script>

<style scoped>
/* Your component's styles go here */
.image-pallet {
  @apply absolute hidden lg:block top-2/4;
  left: -50%;
}
</style>
